module.exports = __webpack_public_path__ + "media/27.779843d7.ogg";